import { emitEvent } from "../../../hooks/useEventEmitter";

export const SAVE_AND_MOVE_NEXT_TIMELINE_EVENT = 'SAVE_AND_MOVE_NEXT_TIMELINE_EVENT';

export type SaveAndMoveNextTimelinePayload = {
  timelineItemIndex: number;
  savedMilestoneName?: string;
  savedMilestoneKey?: string;
  savedMilestoneTime?: string | Date | number;
};

export const fireSaveAndMoveNextTimelineEvent = (
  timelineItemIndex: number,
  payload?: Omit<SaveAndMoveNextTimelinePayload, "timelineItemIndex">,
) => {
  emitEvent(SAVE_AND_MOVE_NEXT_TIMELINE_EVENT, {
    timelineItemIndex,
    ...payload,
  });
};
